export default __webpack_public_path__ + "static/media/020_start.vp9.9b0899a0.webm";